import { ReactNode } from 'react';
import { TalentsContextProvider } from '../Context';

export const ContextProvider: React.FC<{ children: ReactNode }> = (props) => {
    return <TalentsContextProvider>{props.children}</TalentsContextProvider>;
};
